import { format } from "date-fns";

export function currencyLabel(currencyCode: string): string {
  return currencyCode === "USD" ? "$" : currencyCode;
}

export function moneyStep(decimals: number): number {
  return 1 / 10 ** decimals;
}

export function formatMoney(value: string, currencyCode: string): string {
  return currencyCode === "USD" ? `$${value}` : `${currencyCode} ${value}`;
}

export function formatAssetSize(sizeBytes: number): string {
  if (sizeBytes < 1_000) return `${sizeBytes} B`;
  if (sizeBytes < 1_000_000) return `${Math.round(sizeBytes / 1_000)} KB`;
  return `${(sizeBytes / 1_000_000).toFixed(1)} MB`;
}

export function parseAsins(value: string): string[] {
  return [
    ...new Set(
      value
        .toUpperCase()
        .split(/[\s,]+/)
        .map((item) => item.trim())
        .filter((item) => /^[A-Z0-9]{10}$/.test(item)),
    ),
  ];
}

/** Splits comma/newline separated keyword input into unique, trimmed, non-empty values. */
export function parseKeywordList(value: string): string[] {
  return [
    ...new Set(
      value
        .split(/[,\n]+/)
        .map((item) => item.trim())
        .filter(Boolean),
    ),
  ];
}

/** Case-insensitive identity of a keyword row, used to deduplicate per match type. */
export function keywordKey(matchType: string, keyword: string): string {
  return `${matchType}\u0000${keyword.toLowerCase()}`;
}

export function initialName(prefix: string) {
  return `${prefix} - ${format(new Date(), "M/d/yyyy HH:mm:ss.SSS")}`;
}
